import router from "./router/index.js";
import { MessageBox } from "element-ui";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false }); // NProgress Configuration
// function hasPermission(roleList) {

// }

// const whiteList = ['/login', '/authredirect']

router.beforeEach((to, from, next) => {
    NProgress.start();
    let flag = store.state.user.isSave;
    if (to.path === "/box/createANEWproduct" && !Object.keys(to.params).length) {
        // 当进入这个页面进行记录
        store.state.user.isSave = true; // 改变信号
        store.state.user.isCache = true; // 是否缓存，进入新建产品页缓存组件，避免关闭之后缓存还在
        next();
    } else {
        if (flag) {
            // 如果路由发生变化判断信号
            MessageBox.confirm("您确定要退出此页面?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    store.state.user.isSave = false;
                    next();
                })
                .catch(() => {
                    NProgress.done();
                });
        } else {
            next();
        }
    }
});

router.afterEach(() => {
    NProgress.done();
});
